/**
 * @file m站 行程订单详情
 */

import React, {Component} from 'react';
import storage from 'store'
import moment from 'moment'
import {ActionSheet, NavBar, List, WingBlank, Toast, Icon, Button} from 'antd-mobile';
import NavBarComponent from '../../component/common/NavBarComponent'
import {parseStateToSearch, parseSearchToState} from '../../util/util.js';
import { pad } from '../../util/base';
import {Http, urls} from '../../api/index';
import './routeOrder.scss';
const isIPhone = !!window.navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
const isWX = window.navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1 ? true:false;
let wrapProps;
if (isIPhone) {
  wrapProps = {
    onTouchStart: e => e.preventDefault(),
  };
}
const Item = List.Item;
let ordTimer;

class RouteOrder extends Component {
    constructor() {
        super();
        this.state = {
            loading: false,
            navTitle: '订单详情',
            orderNo: '',
            billNo: '',
            text: '',
            process: {},
            licenseVerify: true,
            verifyResult: {},
            unpayedContinueBill: {},
            customerServicePhone: '',
            car: {},
            order: {},
            months: [],
            weeks: [],
            hours: [],
            time: '', // 倒计时
            timeStamp: '',
            timeEndClass: '',
            endDate: '' // 支付截止时间
        };
    }

    componentDidMount() {
        moment.locale('en-NZ');
        this.init();
    }

    componentWillReceiveProps(props){
        this.init();
    }

    componentWillUnmount() {
        clearInterval(ordTimer);
    }

    init() {
        const {history} = this.props;
        const search = history.location.search;
        let routeOrderParams = parseSearchToState(search);
        setTimeout(() => {
            this.setState({
                navTitle: routeOrderParams.type || '订单详情',
                orderNo: routeOrderParams.orderNo,
                timeEndClass: ''
            })
            this.getDetail()
        }, 0);
    }

    setTimeDown() {
        ordTimer = setInterval(() => {
        let nowDate = new Date(this.state.timeStamp); 
        let createdTimes = new Date();
        let endDate = new Date(this.state.endDate.replace(/-/g,'/') || new Date(createdTimes.setHours() + 1));
        if(this.state.timeStamp >= endDate.getTime()){
            this.setState({
                timeEndClass: 'gray-disabled',
                time:'00:00:00',
            })
            clearInterval(ordTimer);
            return false;
        }
        
        let totalSeconds = parseInt((endDate - nowDate) / 1000);
        let modulo = totalSeconds % (60 * 60 * 24);
        let hours = pad(Math.floor(modulo / (60 * 60))) || '00';
        modulo = modulo % (60 * 60);
        let minutes = pad(Math.floor(modulo / 60)) || '00';
        let seconds = pad(modulo % 60) || '00';
    
        
        //页面显示时间
        this.setState({
            time: `${hours}:${minutes}:${seconds}`,
            timeStamp:Number(this.state.timeStamp)+1000
        })
        //停止定时
        if (hours == '00' && minutes == '00' && seconds == '00') {
            this.setState({
                timeEndClass: 'gray-disabled',
            })
            clearInterval(ordTimer);
        }
        }, 1000)
    }

    getDetail() {
        this.setState(() => {
            return {loading: true};
        });
        let url = urls.orderDetail;
        let data = { orderNo: this.state.orderNo };
        Http.post({ url, data }).then(res => {
            const { process, licenseVerify, unpayedContinueBill, customerServicePhone, car, order, verifyResult } = res.data;
            this.setState({
                timeStamp:res.timeStamp,process, licenseVerify, unpayedContinueBill, customerServicePhone, car, order, verifyResult, endDate: order.payDeadlineTime || '', loading: false
            })
            order.orderStatus === 0 && this.setTimeDown()
            this.outPutTime(order)
        })
    }

    outPutTime(order) {
        const weekJson = { 1: '周一', 2: '周二', 3: '周三', 4: '周四', 5: '周五', 6: '周六', 7: '周日' };
        let times = [moment(order.bookingGaincarDateTime), moment(order.bookingBackcarDateTime)];
        let months = times.map(item => item.format('MM月DD日'));
        let weeks = times.map(item => weekJson[item.format('E')]);
        let hours = times.map(item => item.format('HH:mm'));
        this.setState({
            months, weeks, hours
        })
    }

    cancelOrder() {
        const {history} = this.props
        history.push({
            pathname: '/cancelOrder',
            search: parseStateToSearch({id: this.state.orderNo})
        })
    }

    goCost() {
        const {history} = this.props
        history.push({
            pathname: '/costDetail',
            search: parseStateToSearch({orderNo: this.state.orderNo})
        })
    }

    goStore(e) {
        let storeId = e.id;
        let loc = e.loc;
        const {history} = this.props
        history.push({
            pathname: '/storeDetail',
            search: parseStateToSearch({storeId: storeId, loc: loc})
        })
    }

    location(e) {
        let arr = e === 'qu' ? this.state.order.bookingGaincarStoreCoordinate : this.state.order.bookingBackcarStoreCoordinate;
        this.showActionSheet(e, arr);
    }

    showActionSheet = (e, arr) => {
        let BUTTONS;
        if (isIPhone) {
            BUTTONS = ['百度地图', '高德地图','苹果地图', '取消'];
        }else{
            BUTTONS = ['百度地图', '高德地图', '取消'];
        }
        ActionSheet.showActionSheetWithOptions({
            options: BUTTONS,
            cancelButtonIndex: BUTTONS.length - 1,
            // destructiveButtonIndex: BUTTONS.length - 2,
            // title: 'title',
            message: '请选择地图',
            maskClosable: true,
            'data-seed': 'logId',
            wrapProps,
        },
        (buttonIndex) => {
            // 苹果地图
            if(buttonIndex===2){
                if (isIPhone) {
                let loadTime = new Date();
                window.location.href = `http://maps.apple.com/?address=${e === 'qu' ? this.state.order.bookingGaincarStoreName : this.state.order.bookingBackcarStoreName}-${''}&ll=${arr.split(',')[1]},${arr.split(',')[0]}&z=10&t=s`;
                setTimeout(()=>{
                    let outTime = new Date()
                    if(outTime - loadTime > 600){
                        if(isWX){
                        window.location.href = 'https://apps.apple.com/cn/app/%E5%9C%B0%E5%9B%BE/id915056765';
                        // Toast.info('您没有安装苹果地图,请安装苹果地图后重试');
                        }
                    }           
                },1000)
                }
            };
            // 百度地图
            if(buttonIndex===0){
                window.location.href = `http://api.map.baidu.com/marker?location=${arr.split(',')[1]},${arr.split(',')[0]}&title=${e === 'qu' ? this.state.order.bookingGaincarStoreName : this.state.order.bookingBackcarStoreName}&content=${''}&output=html&src=izu-M`;
            }
            // 高德地图
            if(buttonIndex===1){
                window.location.href = `https://uri.amap.com/marker?position=${arr.split(',')[0]},${arr.split(',')[1]}&name=${e === 'qu' ? this.state.order.bookingGaincarStoreName : this.state.order.bookingBackcarStoreName}-${''}&callnative=1`;
            }
        });
    }

    // 去支付
    payTypezf(zfpay) {
        if (this.state.timeEndClass === 'gray-disabled') {
            return false
        }
        let url = urls.payTypezf;
        let data = {
            bizType: 2, orderNo: this.state.orderNo
        };
        Http.post({ url, data }).then(res => {
            setTimeout(() => {
                this.setState({
                    billNo: res.data.paymentInfo.billNo
                })
                this.payment()
            }, 0);
        })
    }

    payment() {
        storage.remove('serialNo')
        const param = {
            orderNo: this.state.orderNo,
            billNo: this.state.billNo,
            price: this.state.order.unpayedOrderAmount
        }
        this.props.history.push(`/payment${parseStateToSearch(param)}`)
    }



    render() {
        return (
            <div id="routeOrder" className="page">
                <NavBarComponent>
                    <NavBar 
                      icon={<Icon type="left" color='#333' />} 
                      onLeftClick={() => {this.props.history.goBack()}} 
                      mode='light'>{this.state.navTitle}</NavBar>
                </NavBarComponent>
                {this.state.order.orderStatus !== 100 ? 
                    <div>
                        {this.state.verifyResult.code === 0 && (this.state.licenseVerify === true || this.state.licenseVerify === 'true') ? 
                        <div className="notice">请到"首汽租车"app中进行取车操作~</div> :
                        <div className="notice">到门店取车前，请提前完成实名和驾照认证、并绑定本人信用卡，否则将无法取车，详情可咨询客服{window.LXOptions.qaMobile}</div>
                        }
                    </div> :
                    <div style={{display: 'none'}}></div>
                }
                <WingBlank>
                    {this.state.order.orderStatus == 0 && this.state.order.orderPaytimeType == 0 ? 
                        <div className="pay">
                            <div className="pay-d">
                                <span>请在<span className="red">{this.state.time}</span>内完成支付</span>
                                <span className="pay-m">￥{this.state.order.unpayedOrderAmount}</span>
                            </div>
                            <div className={['pay-b', this.state.timeEndClass === 'gray-disabled' ? 'gray-disabled' : ''].join(' ')} onClick={() => {this.payTypezf()}}>
                                <span>去支付</span>
                            </div>
                        </div> :
                        <div style={{display: 'none'}}></div>
                    }
                    {this.state.order.orderStatus === 0 ? <div className="line mb10"></div> : <div style={{display: 'none'}}></div>}
                    {this.state.verifyResult.code !== 0 || !this.state.licenseVerify || this.state.licenseVerify === 'false' ? 
                        <div className="line"></div> :
                        <div style={{display: 'none'}}></div>
                    }
                    {(this.state.order.orderStatus === 0 || this.state.order.orderStatus === 8 || this.state.order.orderStatus === 9 || this.state.order.orderStatus === 10) && this.state.order.orderPaytimeType === 1 ?
                        <div className="mt12 font13 c3 mb12">请在{this.state.months[0]} {this.state.hours[0]}前到店取车</div> :
                        <div style={{display: 'none'}}></div>
                    }
                    <div className="card h-shadow">
                        <div className="header">
                        <div className="img">
                            <img mode="widthFix" src={this.state.car.pictureUrl} />
                        </div>
                        <div className="ml5">
                            <div className="font14 c3 mt5 weight">{this.state.car.modelName}</div>
                            <div className="font11 c9 mt5">{this.state.car.gearboxType} {this.state.car.passengerCount}座 {this.state.car.outputVolume}L {this.state.car.vehicleLicense}</div>
                        </div>
                        </div>
                        <div className="line mb15"></div>
                        <div className="main">
                        <div className="main-text">
                            <div>{this.state.months[0]}</div>
                            <div>{this.state.weeks[0]} {this.state.hours[0]}</div>
                        </div>
                        <div className="main-center">
                            <div>{this.state.order.tenancyDays}天</div>
                            <div className="line"></div>
                        </div>
                        <div className="main-text">
                            <div>{this.state.months[1]}</div>
                            <div>{this.state.weeks[1]} {this.state.hours[0]}</div>
                        </div>
                        </div>
                        <div className="footer">
                        <div className="footer-row">
                            <div className="row-name">
                            <span className="iconfont icon-radio red"></span>
                            <span className="">{this.state.order.bookingGaincarStoreName}</span>
                            </div>
                            <div className="row-icon">
                            <span onClick={() => {this.location('qu')}} className="iconfont icon-location"></span>
                            <a className="iconfont icon-cell" href={'tel:' + this.state.order.bookingGaincarStoreTel}></a>
                            </div>
                        </div>
                        <div className="store-text" onClick={() => {this.goStore({id: this.state.order.bookingGaincarStoreId, loc: this.state.order.bookingGaincarStoreCoordinate})}}>点击查看门店详情</div>
                        <div className="footer-row">
                            <div className="row-name">
                            <span className="iconfont icon-radio blue"></span>
                            <span className="">{this.state.order.bookingBackcarStoreName}</span>
                            </div>
                            <div className="row-icon">
                                <span onClick={() => {this.location('huan')}} className="iconfont icon-location"></span>
                                <a className="iconfont icon-cell" href={'tel:' + this.state.order.bookingBackcarStoreTel}></a>
                            </div>
                        </div>
                        <div className="store-text" onClick={() => {this.goStore({id: this.state.order.bookingBackcarStoreId, loc: this.state.order.bookingBackcarStoreCoordinate})}}>点击查看门店详情</div>
                        </div>
                    </div>
                    <div className="beizhu mt20"><div>备注信息</div><div className="ml5 mr5">{this.state.order.trafficNumber || '无'}</div></div>
                    <div className="line mt12 mb12"></div>
                    <div className="beizhu">
                        <div>费用明细</div>
                        <div onClick={() => {this.goCost()}} className="free">
                            <span>点击查看</span>
                            <span className="iconfont icon-more"></span>
                        </div>
                    </div>
                    <div className="line mt12"></div>
                    <div className="detail">
                        <span>订单编号：{this.state.order.orderNo}</span>
                        <span>下单时间：{this.state.process.createTime}</span>
                        {this.state.order.orderStatus === 50 || this.state.order.orderStatus === 60 ? 
                            <span>取车时间：{this.state.process.firstGaincarTime}</span> :
                            <span style={{display: 'none'}}></span>
                        }
                        {this.state.order.orderStatus === 60 ? 
                            <span>还车时间：{this.state.process.lastBackcarTime}</span> :
                            <span style={{display: 'none'}}></span>
                        }
                        {this.state.order.orderStatus === 100 ? 
                            <span>取消时间：{this.state.process.orderCancelTime}</span> :
                            <span style={{display: 'none'}}></span>
                        }
                    </div>
                    {this.state.order.orderStatus === 0 || this.state.order.orderStatus === 8 || this.state.order.orderStatus === 9 || this.state.order.orderStatus === 10 ?
                        <div className="mt20 text-center">
                            <Button onClick={() => {this.cancelOrder()}} className="font-fff ml0" type="warning">取消订单</Button>
                        </div> : 
                        <div style={{display: 'none'}}></div>
                    }
                </WingBlank>
            </div>
        );
    }
}

export default RouteOrder;
